var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshExp = function SvgRefreshExp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none",
    stroke: "#727582",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M8 14s-3-2.118-3-6 3-6 3-6 3 2.118 3 6-3 6-3 6m0 0c-3.809 0-6.666-2.823-6.666-7.059 1.5-.334 2.718.28 3.651.944M8.001 14c3.81 0 6.666-2.823 6.666-7.059-1.5-.334-2.718.28-3.65.944"
  })));
};
export default SvgRefreshExp;